import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ITravelerInformation,
  ITraveler,
  ITravelerFormFields,
} from "./travelerInformation.interfaces";
import { isValid, format } from "date-fns";

export interface IFormFieldPayload {
  key: string;
  value: string;
}

export const initialState: ITravelerInformation = {
  travelers: [],
  currentTraveler: 0,
  sameAsContactPerson: false,
};

export const travelerInformationSlice = createSlice({
  name: "travelerInformation",
  initialState,
  reducers: {
    goToTraveler: (state, action: PayloadAction<number>) => {
      state.currentTraveler = action.payload;
    },
    setTravelersList: (state, action: PayloadAction<ITraveler[]>) => {
      state.travelers = action.payload;
    },
    setTravelerState: (
      state,
      action: PayloadAction<{ index: number; values: ITravelerFormFields }>,
    ) => {
      const { index, values: incomingValues } = action.payload;

      if (index < 0 || index >= state.travelers.length) {
        return;
      }

      let formattedDate = incomingValues.dateOfBirth;
      if (formattedDate && isValid(new Date(formattedDate))) {
        formattedDate = format(new Date(formattedDate), "yyyy-MM-dd");
      } else {
        formattedDate = "";
      }

      const genderType =
        Object.keys(incomingValues).find((key) => key.match("genderType")) ||
        "";
      const genderKey = genderType as keyof ITravelerFormFields;
      let trimmedGenderType = incomingValues[genderKey] || "";

      delete incomingValues[genderKey];
      const updatedValues = {
        ...incomingValues,
        dateOfBirth: formattedDate,
        genderType: trimmedGenderType,
      };

      state.travelers[index] = {
        ...state.travelers[index],
        formFields: {
          ...state.travelers[index].formFields,
          ...updatedValues,
        },
      };
    },
    setSameAsContactPerson: (state, action: PayloadAction<boolean>) => {
      state.sameAsContactPerson = action.payload;
    },
    resetTravelerInformation: (state) => {
      state.travelers = [];
      state.sameAsContactPerson = false;
    },
    setFullTravelerInformationSlice: (
      state,
      action: PayloadAction<ITravelerInformation>,
    ) => {
      return action.payload;
    },
  },
});
export const {
  setTravelerState,
  setTravelersList,
  setSameAsContactPerson,
  goToTraveler,
  resetTravelerInformation,
  setFullTravelerInformationSlice,
} = travelerInformationSlice.actions;
